import './TestingEnvironment.scss';
import { connect } from 'react-redux';
import TestingEnvironment from './TestingEnvironment';
import State from '../../Services/State';

export default connect(State)(TestingEnvironment);
